var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    fill: "#057cb9",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.91,3.09v23.81H3.09V3.09h23.81M26.91,0H3.09C1.39,0,0,1.39,0,3.09v23.81c0,1.71,1.39,3.09,3.09,3.09h23.81c1.71,0,3.09-1.39,3.09-3.09V3.09C30,1.39,28.61,0,26.91,0h0Z",
    fill: "#00699f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.19,15l5.85-5.85c.6-.6.6-1.58,0-2.19-.6-.6-1.58-.6-2.19,0l-5.85,5.85-5.85-5.85c-.6-.6-1.58-.6-2.19,0-.6.6-.6,1.58,0,2.19l5.85,5.85-5.85,5.85c-.6.6-.6,1.58,0,2.19.3.3.7.45,1.09.45s.79-.15,1.09-.45l5.85-5.85,5.85,5.85c.3.3.7.45,1.09.45s.79-.15,1.09-.45c.6-.6.6-1.58,0-2.19l-5.85-5.85Z",
    fill: "#00699f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.df030c3da308522c4727563abb38325d.svg";
export { ForwardRef as ReactComponent };